function initSizeToggle() {
  document.addEventListener('click', function (event) {
    var toggleSwitch = event.target.closest('[data-size-toggle] .size-toggle__switch');
    if (!toggleSwitch) return;

    var toggleWrap = toggleSwitch.closest('[data-size-toggle]');
    var fieldset = toggleWrap.closest('fieldset');
    if (!fieldset) return;

    var isAlt = toggleSwitch.getAttribute('aria-checked') === 'true';
    var next = !isAlt;
    toggleSwitch.setAttribute('aria-checked', String(next));

    var sizeButtons = fieldset.querySelectorAll('[data-standard-size]');
    sizeButtons.forEach(function (button) {
      var target = button.querySelector('.size-toggle-target');
      if (!target) return;
      target.textContent = next ? button.dataset.altSize : button.dataset.standardSize;
    });
  });
}

document.addEventListener('DOMContentLoaded', initSizeToggle);